export default __webpack_public_path__ + "static/media/mui.4401d847.png";